import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=23b27563&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports